import { strings } from "@resource/common";
import { useCallback, useEffect, useRef, useState } from "react";

export function StartCountdown({ startsIn }: { startsIn: number }) {
  const [currentStartsInMinutes, setCurrentStartsInMinutes] =
    useState(startsIn);
  const interval = useRef<NodeJS.Timeout>();

  const clear = useCallback(() => {
    if (interval.current) {
      clearInterval(interval.current);
    }
  }, []);

  useEffect(() => {
    clear();
    interval.current = setInterval(() => {
      setCurrentStartsInMinutes((s) => {
        const newTime = s - 1;
        if (newTime < -1) {
          clear();
        }
        return newTime;
      });
    }, 60000);
    return () => clear();
  }, [clear]);

  const startsInString = `Starting in ${strings.pluralize(
    "min",
    currentStartsInMinutes
  )}`;

  return currentStartsInMinutes > 0 ? (
    <p className="text-accent text-body-sm-heavy">{startsInString}</p>
  ) : null;
}
